import { Call, Mail } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormLabel, Link, OutlinedInput, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import Logo from "../../icons/Logo";
import Proxy from "../../models/Proxy";
import { Contact, Person } from "../../models/Types";

function getIcon(c: Contact) {
    switch (c.Type) {
        case 'Phone': return <Call color="error" sx={{ marginRight: 1 }} />
        case 'Email': return <Mail color="error" sx={{ marginRight: 1 }} />;
    }
}

export interface PersonUserProps {
    typeName: React.ReactNode
    client?: Person
    contacts: Contact[]
    onCreate: (userId: number) => void
    onAddClick?: () => void
}

export function PersonUser({ typeName, contacts, client, onCreate, onAddClick }: PersonUserProps) {
    const [key, setKey] = useState<number[]>([]);
    const [edit, setEdit] = useState(false);
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<string>();
    const [lp, setLp] = useState<{ UserName: string, Password: string }>();

    const theme = useTheme();

    let cs = contacts?.filter(x => x.Type == 'Phone' || x.Type == 'Email');
    if (!client || !client.Id) {
        return <>
            <Box sx={styles.box}>
                <Logo style={{ float: 'left', height: '3em', marginRight: '1rem' }} color={theme.palette.grey[500]} />
                <Typography color="grey">После создания <b>{typeName}</b> может получить пользовательский доступ к вашему проекту</Typography>
                {cs?.length ?
                    undefined :
                    <Typography variant="body2" color="grey">
                        Для приглашения пользователя
                        необходимо <Link color="primary" style={{ cursor: 'pointer' }} onClick={onAddClick}>задать</Link> хотя бы
                        один E-Mail/Телефон в разделе <b>Контакты</b>
                    </Typography>}

            </Box>
        </>;
    }

    function handleEdit() {
        var login = '';
        while (login.length < 8) {
            login = parseInt(Math.random().toString().replace("0.", "")).toString(16).substring(0, 8);
        }

        setLp({ UserName: login });

        sending && setSending(false);
        setEdit(true);
    }

    function handleSend() {
        setSending(true);
        setError('');
        Proxy.post('PersonCreateUser', {
            Id: client?.Id,
            UserName: lp?.UserName,
            Contacts: contacts
                .filter(x => x.Type === 'Phone' || x.Type === 'Email')
                .filter((x, i) => key.indexOf(i) >= 0)
        }).then(x => {
            if (x.success) {
                client && (client.UserId = x.result.Id);
                onCreate(x.result.Id);
                setSent(true);
                setLp(x.result);
            } else {
                setSending(false);
                if (x.Message) {
                    setError(x.Message.indexOf('Username') >= 0 && x.Message.indexOf('is already taken') > 0 ? 'Логин занят' : x.Message);
                }
            }
        });
    }

    function handleChecked(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
        var i = parseInt(e.target.name);
        if (checked) {
            setKey([...key, i])
        } else {
            setKey(key.filter(x => x != i));
        }
    }

    if (sent) {
        return <>
            <Typography color="primary" variant="button" sx={styles.box}><Logo style={{ height: '1em' }} /> Приглашение выслано</Typography>
            <Dialog open={!!lp}>
                <DialogTitle>Пользователь успешно создан</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div>Логин: {lp?.UserName}</div>
                        <div>Пароль: {lp?.Password}</div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLp(undefined)}>Закрыть</Button>
                </DialogActions>
            </Dialog>
        </>
    } else if (client.UserId) {
        return <Box sx={{ marginTop: 1, display: 'flex' }}>
            <Logo style={{ float: 'left', height: '3em', marginRight: '1rem' }} />
            <Box sx={{ flexDirection: 'column', justifyContent: 'space-around' }}>
                <Typography color="primary">Пользователь создан</Typography>
                <Typography color="primary" variant="body2" sx={{ whiteSpace: 'nowrap' }}>Может использовать Личный кабинет</Typography>
            </Box>
        </Box>;
    } else {
        if (edit) {
            return <Dialog onClose={() => setEdit(false)} open={edit}>
                <DialogTitle>Создание пользователя</DialogTitle>
                <DialogContent sx={{ maxWidth: 450 }}>
                    <FormControl>
                        <FormLabel>Логин</FormLabel>
                        <OutlinedInput value={lp.UserName} onChange={e => setLp({ UserName: e.target.value })} required />
                    </FormControl>
                    <Typography component="div" mt={1} variant="caption" color="textSecondary">Можно ввести свой вариант логина или оставить сгенерированным</Typography>
                    {error ? <Typography variant="caption" color="error">{error}</Typography> : null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSend} disabled={sending} variant="contained">{sending ? 'Создаем ЛК пользователя...' : 'Создать пользователя'}</Button>
                    <Button onClick={() => setEdit(false)} autoFocus>Отмена</Button>
                </DialogActions>
            </Dialog>;
        } else {
            return <>
                <Box sx={styles.box}>
                    <Logo style={{ float: 'left', height: '3em', marginRight: '1rem' }} color={theme.palette.grey[500]} />
                    <Typography color="grey" fontWeight="bold">Пользователь</Typography>
                    <Typography color="grey">не создан</Typography>
                </Box>

                <Button sx={styles.box}
                    variant="outlined"
                    color="primary"
                    onClick={handleEdit}
                    startIcon={<Logo style={{ height: '1em' }} />}>
                    Создать Личный кабинет
                </Button>
            </>;
        }
    }
}

const styles = {
    box: {
        marginTop: 1
    }
}